import React, { useEffect, useState } from 'react';
import Header from '../../../component/layout/Header';
import Footer from '../../../component/layout/Footer';
import Page from '../../../component/utility/Page';
import DataTable from 'react-data-table-component';
import { custTableStyles } from '../../../style/color';
import { 
    Row, 
    Col, 
    Card, 
    CardBody, 
    CardHeader, 
    Button, 
    Modal, 
    ModalHeader, 
    ModalBody, 
    ModalFooter, 
    Form, 
    FormGroup, 
    Label, 
    Input,
    InputGroup,
    InputGroupText,
    Badge,
    Spinner,
    Alert
} from 'reactstrap';
import { 
    FaBan, 
    FaCheck, 
    FaEdit, 
    FaTrash, 
    FaSync,
    FaSearch,
    FaCalendarAlt,
    FaMoneyBillWave,
    FaFileInvoiceDollar,
    FaClipboardList,
    FaFilter,
    FaDownload,
    FaPlus
} from 'react-icons/fa';

const JournalList = () => {
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [editModal, setEditModal] = useState(false);
    const [editData, setEditData] = useState(null);
    const [editLoading, setEditLoading] = useState(false);
    const [coaList, setCoaList] = useState([]);
    const [bankList, setBankList] = useState([]);
    const [expandedRowId, setExpandedRowId] = useState(null);
    const [productList, setProductList] = useState([]);
    const [expandedRow, setExpandedRow] = useState(null);
    const [uomList, setUomList] = useState([]);

    // Default filter dates (can be made dynamic)
    const fromDate = '2025-07-04';
    const toDate = '2025-07-05';

    const fetchJournalList = async () => {
        setLoading(true);
        try {
            const postData = [{
                org_id: 114,
                user_id: 10055,
                payment_type: 1,
                status: 1,
                from_date: fromDate,
                to_date: toDate
            }];
            const response = await fetch('https://api2.boxfarming.in/wsapi/v3/index.php/Accounts/journal_entry_list', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(postData)
            });
            const data = await response.json();
            setTableData(data);
            setFilteredData(data);
        } catch (error) {
            setTableData([]);
            setFilteredData([]);
        }
        setLoading(false);
    };

    const fetchUomList = async () => {
        const postData = [{ org_id: 114 }];
        const response = await fetch('https://api2.boxfarming.in/wsapi/v3/index.php/Master/box_uom_list', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(postData)
        });
        return await response.json();
    };

    // Search functionality
    const handleSearch = (value) => {
        setSearchTerm(value);
        if (value === '') {
            setFilteredData(tableData);
        } else {
            const filtered = tableData.filter(item =>
                (item.journal_number && item.journal_number.toLowerCase().includes(value.toLowerCase())) ||
                (item['Dr From'] && item['Dr From'].toLowerCase().includes(value.toLowerCase())) ||
                (item['Cr To'] && item['Cr To'].toLowerCase().includes(value.toLowerCase())) ||
                (item.payment_ref_no && item.payment_ref_no.toLowerCase().includes(value.toLowerCase())) ||
                (item.journal_date && item.journal_date.includes(value))
            );
            setFilteredData(filtered);
        }
    };

    useEffect(() => {
        fetchJournalList();
    }, []);

    // Fetch COA list for dropdowns in modal
    useEffect(() => {
        const fetchCOA = async () => {
            try {
                const postData = [{ org_id: 114, user_id: 10055, ac_group_id: 0 }];
                const response = await fetch('https://api2.boxfarming.in/wsapi/v3/index.php/Accounts/coa_list', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(postData)
                });
                const data = await response.json();
                setCoaList(data);
            } catch (error) {
                setCoaList([]);
            }
        };
        fetchCOA();
    }, []);

    // Fetch bank list for dropdown in modal
    useEffect(() => {
        const fetchBankList = async () => {
            try {
                const postData = [{ org_id: 114, user_id: 10055 }];
                const response = await fetch('https://api2.boxfarming.in/wsapi/v3/index.php/Accounts/view_bank_list', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(postData)
                });
                const data = await response.json();
                setBankList(data);
            } catch (error) {
                setBankList([]);
            }
        };
        fetchBankList();
    }, []);

    // Fetch product list for mapping product_id to details
    useEffect(() => {
        const fetchProductList = async () => {
            try {
                const postData = [{"org_id":114,"user_id":10055,"item_type_id":1}];
                const response = await fetch('https://api2.boxfarming.in/wsapi/v3/index.php/Accounts/item_list', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(postData)
                });
                const data = await response.json();
                setProductList(data);
            } catch (error) {
                setProductList([]);
            }
        };
        fetchProductList();
    }, []);

    // Fetch UOM list
    useEffect(() => {
        const getUomList = async () => {
            try {
                const data = await fetchUomList();
                setUomList(data);
            } catch (error) {
                setUomList([]);
            }
        };
        getUomList();
    }, []);

    // Handle edit button click
    const handleEdit = (row) => {
        setEditData({ ...row });
        setEditModal(true);
    };

    // Handle approve button click (edit modal)
    const handleApprove = async (row) => {
        setEditLoading(true);
        try {
            // Prepare payload for approve
            let payload = { ...row };
            payload.approve_status = 1;
            // Ensure products is an array, not string
            if (typeof payload.products === 'string') {
                try {
                    payload.products = JSON.parse(payload.products);
                } catch (e) {
                    payload.products = [];
                }
            }
            // Rename keys for API
            if (payload['Dr From']) {
                payload.dr_from = payload['Dr From'];
                delete payload['Dr From'];
            }
            if (payload['Cr To']) {
                payload.cr_to = payload['Cr To'];
                delete payload['Cr To'];
            }
            if (payload.description) {
                payload.desc = payload.description;
                delete payload.description;
            }
            // Add org_id and user_id if missing
            payload.org_id = 114;
            payload.user_id = 10055;
            // Add date if missing
            if (!payload.date) payload.date = fromDate;
            await fetch('https://api2.boxfarming.in/wsapi/v3/index.php/Accounts/journal_edit_approve', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify([payload])
            });
            console.log('Approve payload:', payload);
            setEditModal(false);
            fetchJournalList();
        } catch (error) {}
        setEditLoading(false);
    };

    // Handle reject button click (edit modal)
    const handleReject = async (row) => {
        setEditLoading(true);
        try {
            // Prepare payload for reject
            let payload = { ...row };
            payload.approve_status = 2;
            // Ensure products is an array, not string
            if (typeof payload.products === 'string') {
                try {
                    payload.products = JSON.parse(payload.products);
                } catch (e) {
                    payload.products = [];
                }
            }
            // Rename keys for API
            if (payload['Dr From']) {
                payload.dr_from = payload['Dr From'];
                delete payload['Dr From'];
            }
            if (payload['Cr To']) {
                payload.cr_to = payload['Cr To'];
                delete payload['Cr To'];
            }
            if (payload.description) {
                payload.desc = payload.description;
                delete payload.description;
            }
            // Add org_id and user_id if missing
            payload.org_id = 114;
            payload.user_id = 10055;
            // Add date if missing
            if (!payload.date) payload.date = fromDate;
            await fetch('https://api2.boxfarming.in/wsapi/v3/index.php/Accounts/journal_edit_approve', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify([payload])
            });
            setEditModal(false);
            fetchJournalList();
        } catch (error) {}
        setEditLoading(false);
    };

    // Payment type and method mappings
    const paymentTypeMap = { 1: 'Payment', 2: 'Receipt', 3: 'Contra', 4: 'Journal' };
    const paymentMethodMap = { 1: 'Online', 2: 'Cash', 3: 'Cheque' };

    const getStatusBadge = (status) => {
        switch(status) {
            case 'Draft':
                return <Badge color="warning" pill>Draft</Badge>;
            case 'Approved':
                return <Badge color="success" pill>Approved</Badge>;
            case 'Rejected':
                return <Badge color="danger" pill>Rejected</Badge>;
            default:
                return <Badge color="secondary" pill>{status}</Badge>;
        }
    };

    const columns = [
        { 
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaClipboardList size={12} />
                    Status
                </div>
            ), 
            selector: row => row.status, 
            sortable: false, 
            wrap: true,
            cell: row => getStatusBadge(row.status),
            width: '100px'
        },
        { 
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaFileInvoiceDollar size={12} />
                    Journal ID
                </div>
            ), 
            selector: row => row.journal_id, 
            sortable: true, 
            width: '120px', 
            wrap: true 
        },
        { 
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaMoneyBillWave size={12} />
                    Dr From
                </div>
            ), 
            selector: row => row['Dr From'], 
            sortable: false, 
            wrap: true,
            cell: row => (
                <div className="text-truncate" title={row['Dr From']}>
                    {row['Dr From'] || 'N/A'}
                </div>
            )
        },
        { 
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaMoneyBillWave size={12} />
                    Cr To
                </div>
            ), 
            selector: row => row['Cr To'], 
            sortable: false, 
            wrap: true,
            cell: row => (
                <div className="text-truncate" title={row['Cr To']}>
                    {row['Cr To'] || 'N/A'}
                </div>
            )
        },
        { 
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaFileInvoiceDollar size={12} />
                    Journal Number
                </div>
            ), 
            selector: row => row.journal_number, 
            sortable: false, 
            wrap: true 
        },
        { 
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaClipboardList size={12} />
                    Payment Type
                </div>
            ), 
            selector: row => paymentTypeMap[row.payment_type] || row.payment_type, 
            sortable: false, 
            wrap: true,
            cell: row => (
                <Badge color="info" pill>
                    {paymentTypeMap[row.payment_type] || row.payment_type}
                </Badge>
            )
        },
        { 
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaCalendarAlt size={12} />
                    Journal Date
                </div>
            ), 
            selector: row => row.journal_date, 
            sortable: false, 
            wrap: true 
        },
        { 
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaMoneyBillWave size={12} />
                    Payment Method
                </div>
            ), 
            selector: row => paymentMethodMap[row.payment_method] || row.payment_method, 
            sortable: false, 
            wrap: true,
            cell: row => (
                <Badge color="light" className="text-dark">
                    {paymentMethodMap[row.payment_method] || row.payment_method}
                </Badge>
            )
        },
        { 
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaFileInvoiceDollar size={12} />
                    Payment Ref No
                </div>
            ), 
            selector: row => row.payment_ref_no, 
            sortable: false, 
            wrap: true 
        },
        {
            name: 'Actions',
            cell: row => (
                <div style={{display: 'flex', gap: '8px'}}>
                    {row.status === 'Draft' && (
                        <Button 
                            color="warning" 
                            size="sm" 
                            className="text-white d-flex align-items-center gap-1" 
                            onClick={() => handleEdit(row)}
                        >
                            <FaEdit size={12}/>
                            Edit
                        </Button>
                    )}
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            width: '120px',
        },
    ];

    // Helper to map product_id to product details from item_list
    const getProductDetails = (product_id) => {
        return productList.find(p => String(p.item_id) === String(product_id)) || {};
    };
    
    const getUomDesc = (uom_code) => {
        const uom = uomList.find(u => u.uom_code === String(uom_code));
        return uom ? uom.uom_desc : uom_code;
    };

    // Calculate statistics
    const totalJournals = tableData.length;
    const draftCount = tableData.filter(item => item.status === 'Draft').length;
    const approvedCount = tableData.filter(item => item.status === 'Approved').length;
    const rejectedCount = tableData.filter(item => item.status === 'Rejected').length;

    return (
        <>
            <Header />
            <Page title='Journal Management' breadcrumbs='Home / Accounts / Journal List'>
                <Row className="p-3">
                    <Col xs={12}>
                        {/* Action Bar */}
                        <Card className='mb-4 border-0 shadow-sm'>
                            <CardBody className="py-3">
                                <Row className="align-items-center">
                                    <Col md={8}>
                                        <div className="d-flex gap-2">
                                            <Button
                                                color='primary'
                                                size="sm"
                                                onClick={fetchJournalList}
                                                disabled={loading}
                                                className="d-flex align-items-center gap-2"
                                            >
                                                {loading ? (
                                                    <Spinner size="sm" />
                                                ) : (
                                                    <FaSync size={14} />
                                                )}
                                                {loading ? 'Loading...' : 'Refresh Data'}
                                            </Button>
                                            <Button
                                                color='secondary'
                                                size="sm"
                                                disabled={tableData.length === 0}
                                                className="d-flex align-items-center gap-2 text-white"
                                            >
                                                <FaDownload size={14} />
                                                Export
                                            </Button>
                                            <Button
                                                color='success'
                                                size="sm"
                                                className="d-flex align-items-center gap-2 text-white"
                                            >
                                                <FaPlus size={14} />
                                                New Journal
                                            </Button>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <InputGroup size="sm">
                                            <InputGroupText className="bg-light border-end-0">
                                                <FaSearch className="text-muted" />
                                            </InputGroupText>
                                            <Input
                                                type="search"
                                                placeholder='Search journals, accounts, references...'
                                                value={searchTerm}
                                                onChange={(e) => handleSearch(e.target.value)}
                                                className="border-start-0"
                                            />
                                        </InputGroup>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>

                        {/* Statistics Cards */}
                        {tableData.length > 0 && (
                            <Row className="mb-4">
                                <Col md={3}>
                                    <Card className="border-0 bg-primary text-white">
                                        <CardBody className="text-center py-3">
                                            <FaFileInvoiceDollar size={24} className="mb-2" />
                                            <h5 className="mb-0">{totalJournals}</h5>
                                            <small>Total Journals</small>
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col md={3}>
                                    <Card className="border-0 bg-warning text-white">
                                        <CardBody className="text-center py-3">
                                            <FaClipboardList size={24} className="mb-2" />
                                            <h5 className="mb-0">{draftCount}</h5>
                                            <small>Draft Entries</small>
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col md={3}>
                                    <Card className="border-0 bg-success text-white">
                                        <CardBody className="text-center py-3">
                                            <FaCheck size={24} className="mb-2" />
                                            <h5 className="mb-0">{approvedCount}</h5>
                                            <small>Approved</small>
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col md={3}>
                                    <Card className="border-0 bg-danger text-white">
                                        <CardBody className="text-center py-3">
                                            <FaBan size={24} className="mb-2" />
                                            <h5 className="mb-0">{rejectedCount}</h5>
                                            <small>Rejected</small>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        )}

                        {/* Main Data Table */}
                        <Card className='border-0 shadow-sm'>
                            <CardHeader className="bg-white border-bottom">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        <h5 className="mb-0">Journal Entry Records</h5>
                                        <small className='text-muted'>
                                            {filteredData.length > 0 ?
                                                `Showing ${filteredData.length} of ${tableData.length} journal entries` :
                                                'No journal entries found'
                                            }
                                        </small>
                                    </div>
                                    {searchTerm && (
                                        <Badge color="secondary" className="ms-2">
                                            Filtered: {filteredData.length}
                                        </Badge>
                                    )}
                                </div>
                            </CardHeader>
                            <CardBody className="p-0">
                                {tableData.length === 0 && !loading ? (
                                    <Alert color="info" className="m-3 text-center">
                                        <FaFileInvoiceDollar size={48} className="mb-3 text-muted" />
                                        <p className="mb-2">No journal entries loaded yet</p>
                                        <small>Click "Refresh Data" to fetch the latest journal entries</small>
                                    </Alert>
                                ) : (
                                    <DataTable
                                        title=""
                                        customStyles={custTableStyles}
                                        columns={columns}
                                        data={filteredData}
                                        highlightOnHover
                                        responsive
                                        pagination
                                        paginationPerPage={10}
                                        paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                        progressPending={loading}
                                        progressComponent={
                                            <div className="d-flex flex-column align-items-center justify-content-center py-5">
                                                <Spinner color="primary" />
                                                <p className="mt-2 text-muted">Loading journal entries...</p>
                                            </div>
                                        }
                                        noDataComponent={
                                            <div className="text-center py-5">
                                                <FaSearch size={48} className="text-muted mb-3" />
                                                <p className="text-muted">No journal entries match your search criteria</p>
                                            </div>
                                        }
                                        expandableRows
                                        expandableRowsComponent={({ data }) => {
                                            let products = [];
                                            try {
                                                products = JSON.parse(data.products);
                                            } catch (e) {}
                                            return (
                                                <div style={{padding: '16px', background: '#f9f9f9'}}>
                                                    <div className="d-flex align-items-center gap-2 mb-3">
                                                        <FaClipboardList className="text-primary" />
                                                        <h6 className="mb-0">Product Details</h6>
                                                        <Badge color="secondary" pill>{products.length} items</Badge>
                                                    </div>
                                                    <table className="table table-bordered table-sm mt-2">
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th>#</th>
                                                                <th>Product</th>
                                                                <th>Qty</th>
                                                                <th>Unit Price</th>
                                                                <th>Tax</th>
                                                                <th>UOM</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {products.map((prod, idx) => {
                                                                const prodDetails = getProductDetails(prod.product_id);
                                                                const prodName = prodDetails.item_name ? `${prod.product_id}-${prodDetails.item_name}` : prod.product_id;
                                                                const uomDesc = getUomDesc(prod.uom);
                                                                return (
                                                                    <tr key={idx}>
                                                                        <td>{idx + 1}</td>
                                                                        <td>{prodName}</td>
                                                                        <td>{prod.qty}</td>
                                                                        <td>{prod.unit_price}</td>
                                                                        <td>{prod.tax}</td>
                                                                        <td>{uomDesc}</td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            );
                                        }}
                                    />
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Page>
            <Footer />
            
            {/* Enhanced Edit Modal */}
            <Modal isOpen={editModal} toggle={() => setEditModal(false)} size="xl" backdrop="static" className="modal-dialog-scrollable">
                <ModalHeader toggle={() => setEditModal(false)} className="bg-light border-bottom">
                    <div className="d-flex align-items-center gap-2">
                        <FaEdit className="text-primary" />
                        <div>
                            <h5 className="mb-0">Edit Journal Entry</h5>
                            <small className="text-muted">
                                Journal ID: {editData?.journal_id}
                            </small>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    {editData && (
                        <Form>
                            <Row>
                                {Object.keys(editData).map((key) => {
                                    const hiddenFields = [
                                        'status', 'fiscal_year_id', 'fiscal_period_id', 'currency_code',
                                        'created_by', 'created_at', 'approved_at', 'approved_by'
                                    ];
                                    if (hiddenFields.includes(key)) return null;
                                    
                                    // For Dr From and Cr To, show dropdown
                                    if (key === 'Dr From' || key === 'Cr To') {
                                        let initialValue = coaList.find(acc => (acc.account_code + '-' + acc.account_name) === editData[key]);
                                        if (!initialValue) {
                                            const codeFromEdit = editData[key]?.split('-')[0]?.trim();
                                            initialValue = coaList.find(acc => acc.account_code === codeFromEdit);
                                        }
                                        const selectValue = initialValue ? (initialValue.account_code + '-' + initialValue.account_name) : editData[key];
                                        return (
                                            <Col md={6} key={key}>
                                                <FormGroup className="mb-3">
                                                    <Label><strong>{key}</strong></Label>
                                                    <Input
                                                        type="select"
                                                        value={selectValue}
                                                        onChange={e => setEditData({ ...editData, [key]: e.target.value })}
                                                    >
                                                        {coaList.map(acc => (
                                                            <option key={acc.account_code} value={acc.account_code + '-' + acc.account_name}>
                                                                {acc.account_code} - {acc.account_name} ({acc[Object.keys(acc)[2]]})
                                                            </option>
                                                        ))}
                                                    </Input>
                                                </FormGroup>
                                            </Col>
                                        );
                                    }
                                    
                                    // For payment_type, show dropdown
                                    if (key === 'payment_type') {
                                        return (
                                            <Col md={6} key={key}>
                                                <FormGroup className="mb-3">
                                                    <Label><strong>Payment Type</strong></Label>
                                                    <Input
                                                        type="select"
                                                        value={editData[key]}
                                                        onChange={e => setEditData({ ...editData, [key]: e.target.value })}
                                                    >
                                                        {Object.entries(paymentTypeMap).map(([val, label]) => (
                                                            <option key={val} value={val}>{label}</option>
                                                        ))}
                                                    </Input>
                                                </FormGroup>
                                            </Col>
                                        );
                                    }
                                    
                                    // For payment_method, show dropdown
                                    if (key === 'payment_method') {
                                        return (
                                            <Col md={6} key={key}>
                                                <FormGroup className="mb-3">
                                                    <Label><strong>Payment Method</strong></Label>
                                                    <Input
                                                        type="select"
                                                        value={editData[key]}
                                                        onChange={e => setEditData({ ...editData, [key]: e.target.value })}
                                                    >
                                                        {Object.entries(paymentMethodMap).map(([val, label]) => (
                                                            <option key={val} value={val}>{label}</option>
                                                        ))}
                                                    </Input>
                                                </FormGroup>
                                            </Col>
                                        );
                                    }
                                    
                                    // For bank_id, show dropdown
                                    if (key === 'bank_id') {
                                        return (
                                            <Col md={6} key={key}>
                                                <FormGroup className="mb-3">
                                                    <Label><strong>Bank</strong></Label>
                                                    <Input
                                                        type="select"
                                                        value={editData[key]}
                                                        onChange={e => setEditData({ ...editData, [key]: e.target.value })}
                                                    >
                                                        <option value="">--Select Bank--</option>
                                                        {bankList.map(bank => (
                                                            <option key={bank.bank_id} value={bank.bank_id}>{bank.bank_name}</option>
                                                        ))}
                                                    </Input>
                                                </FormGroup>
                                            </Col>
                                        );
                                    }
                                    
                                    // For products, show editable table with dropdowns for product and UOM
                                    if (key === 'products') {
                                        let products = [];
                                        try {
                                            products = JSON.parse(editData.products);
                                        } catch (e) {}
                                        const handleProductChange = (idx, field, value) => {
                                            const updatedProducts = products.map((prod, i) => i === idx ? { ...prod, [field]: value } : prod);
                                            setEditData({ ...editData, products: JSON.stringify(updatedProducts) });
                                        };
                                        const handleAddProduct = () => {
                                            const newProduct = {
                                                product_id: productList.length > 0 ? productList[0].item_id : '',
                                                qty: 1,
                                                unit_price: 0,
                                                tax: 0,
                                                uom: uomList.length > 0 ? uomList[0].uom_code : ''
                                            };
                                            setEditData({ ...editData, products: JSON.stringify([...products, newProduct]) });
                                        };
                                        const handleDeleteProduct = (idx) => {
                                            const updatedProducts = products.filter((_, i) => i !== idx);
                                            setEditData({ ...editData, products: JSON.stringify(updatedProducts) });
                                        };
                                        return (
                                            <Col md={12} key={key}>
                                                <FormGroup className="mb-3">
                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                        <Label><strong>Products</strong></Label>
                                                        <Button 
                                                            color="primary" 
                                                            size="sm" 
                                                            type="button" 
                                                            onClick={handleAddProduct}
                                                            className="d-flex align-items-center gap-1"
                                                        >
                                                            <FaPlus size={12} />
                                                            Add Product
                                                        </Button>
                                                    </div>
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered table-sm">
                                                            <thead className="table-light">
                                                                <tr>
                                                                    <th width="40">#</th>
                                                                    <th>Product</th>
                                                                    <th width="80">Qty</th>
                                                                    <th width="100">Unit Price</th>
                                                                    <th width="80">Tax</th>
                                                                    <th width="120">UOM</th>
                                                                    <th width="80">Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {products.map((prod, idx) => (
                                                                    <tr key={idx}>
                                                                        <td className="text-center">{idx + 1}</td>
                                                                        <td>
                                                                            <Input
                                                                                type="select"
                                                                                value={prod.product_id}
                                                                                onChange={e => handleProductChange(idx, 'product_id', e.target.value)}
                                                                                size="sm"
                                                                            >
                                                                                {productList.map(item => (
                                                                                    <option key={item.item_id} value={item.item_id}>
                                                                                        {item.item_id}-{item.item_name}
                                                                                    </option>
                                                                                ))}
                                                                            </Input>
                                                                        </td>
                                                                        <td>
                                                                            <Input
                                                                                type="number"
                                                                                value={prod.qty}
                                                                                onChange={e => handleProductChange(idx, 'qty', e.target.value)}
                                                                                size="sm"
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <Input
                                                                                type="number"
                                                                                value={prod.unit_price}
                                                                                onChange={e => handleProductChange(idx, 'unit_price', e.target.value)}
                                                                                size="sm"
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <Input
                                                                                type="number"
                                                                                value={prod.tax}
                                                                                onChange={e => handleProductChange(idx, 'tax', e.target.value)}
                                                                                size="sm"
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <Input
                                                                                type="select"
                                                                                value={prod.uom}
                                                                                onChange={e => handleProductChange(idx, 'uom', e.target.value)}
                                                                                size="sm"
                                                                            >
                                                                                {uomList.map(uom => (
                                                                                    <option key={uom.uom_code} value={uom.uom_code}>
                                                                                        {uom.uom_desc}
                                                                                    </option>
                                                                                ))}
                                                                            </Input>
                                                                        </td>
                                                                        <td className="text-center">
                                                                            <Button 
                                                                                color="danger" 
                                                                                size="sm" 
                                                                                type="button" 
                                                                                onClick={() => handleDeleteProduct(idx)}
                                                                                className="d-flex align-items-center gap-1"
                                                                            >
                                                                                <FaTrash size={10}/>
                                                                            </Button>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                                {products.length === 0 && (
                                                                    <tr>
                                                                        <td colSpan="7" className="text-center text-muted py-3">
                                                                            No products added yet. Click "Add Product" to start.
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </FormGroup>
                                            </Col>
                                        );
                                    }
                                    
                                    // For other fields, show text input
                                    return (
                                        <Col md={6} key={key}>
                                            <FormGroup className="mb-3">
                                                <Label><strong>{key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}</strong></Label>
                                                <Input
                                                    type={key.includes('date') ? 'date' : key.includes('amount') || key.includes('price') ? 'number' : 'text'}
                                                    value={editData[key] || ''}
                                                    onChange={e => setEditData({ ...editData, [key]: e.target.value })}
                                                    disabled={key === 'journal_id'}
                                                    placeholder={`Enter ${key.replace(/_/g, ' ')}`}
                                                />
                                            </FormGroup>
                                        </Col>
                                    );
                                })}
                            </Row>
                        </Form>
                    )}
                </ModalBody>
                <ModalFooter className="bg-light border-top">
                    <div className="d-flex gap-2">
                        <Button 
                            color="success" 
                            onClick={() => handleApprove(editData)} 
                            disabled={editLoading}
                            className="d-flex align-items-center gap-2"
                        >
                            {editLoading ? (
                                <Spinner size="sm" />
                            ) : (
                                <FaCheck />
                            )}
                            {editLoading ? 'Processing...' : 'Approve'}
                        </Button>
                        <Button 
                            color="danger" 
                            onClick={() => handleReject(editData)} 
                            disabled={editLoading}
                            className="d-flex align-items-center gap-2"
                        >
                            {editLoading ? (
                                <Spinner size="sm" />
                            ) : (
                                <FaBan />
                            )}
                            {editLoading ? 'Processing...' : 'Reject'}
                        </Button>
                        <Button 
                            color="secondary" 
                            onClick={() => setEditModal(false)} 
                            disabled={editLoading}
                        >
                            Cancel
                        </Button>
                    </div>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default JournalList;